import React from 'react';

import { Grid } from '@mui/material';
import { TextInput, required } from 'react-admin';
import CommentInput from '../../../comment/CommentInput';

const PrimitiveInput = () => (
  <Grid
    size={{
      xs: 12,
      md: 7,
    }}
  >
    <Grid container>
      <Grid size={12}>
        <TextInput fullWidth source="value" label="New value" validate={required()} />
      </Grid>
      <Grid size={12}>
        <CommentInput
          source="comment"
          helperText={false}
          placeholder="Please explain your decision."
          validate={required()}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default PrimitiveInput;
